import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a1628]/95 backdrop-blur-sm shadow-lg py-2' : 'bg-transparent py-2'}`} data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="flex items-center justify-between" data-id="element-76">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-77">
            <span className="text-[#fbbf24] font-bold text-base sm:text-xl tracking-tight drop-shadow-[0_0_8px_rgba(251,191,36,0.4)]" data-id="element-78">
              KitLenguayLiteratura
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-79">
            <button onClick={() => scrollToSection('que-incluye')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-80">
              Qué incluye
            </button>
            <button onClick={() => scrollToSection('beneficios')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-81">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('bonus')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-82">
              Bonus
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-83">
              Testimonios
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-84">
            <button onClick={() => scrollToSection('oferta')} className="bg-[#dc2626] hover:bg-red-700 text-white font-bold py-2 px-6 rounded-full transition-all transform hover:scale-105 shadow-lg border-2 border-red-500" data-id="element-85">
              COMPRAR
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-86">
            <button onClick={() => scrollToSection('oferta')} className="bg-[#dc2626] text-white text-xs font-bold py-1.5 px-3 rounded-full shadow-lg" data-id="element-87">
              COMPRAR
            </button>
            <button onClick={() => setIsOpen(!isOpen)} className="text-white p-1.5" aria-label="Menu" data-id="element-88">
              {isOpen ? <X size={20} data-id="element-89" /> : <Menu size={20} data-id="element-90" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-[#0a1628] border-t border-gray-800 absolute w-full" data-id="element-91">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-92">
            <button onClick={() => scrollToSection('que-incluye')} className="block w-full text-left px-3 py-3 text-base font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-93">
              Qué incluye
            </button>
            <button onClick={() => scrollToSection('beneficios')} className="block w-full text-left px-3 py-3 text-base font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-94">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('bonus')} className="block w-full text-left px-3 py-3 text-base font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-95">
              Bonus
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-3 py-3 text-base font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-96">
              Testimonios
            </button>
          </div>
        </div>}
    </header>;
}